var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { useEffect, useMemo, useState } from "react";
import { useQuery } from "react-query";
import TextField from "@mui/material/TextField";
import { Autocomplete, CircularProgress } from "@mui/material";
import { debounce } from "lodash";
import { useResources } from "../../../utils/hooks/resources/useResources";
import { ResourceService } from "../../../services/resource/resource.service";
import { useSector } from "../../../utils/hooks/sector/useSectors";
import { SectorType } from "../../../models/sector/sector.model";
import { useCurrentApp } from "../../../utils/hooks/app/useOrganizationApps";
var FilterResourceIdInput = function (_a) {
    var _b;
    var ids = _a.ids, setIds = _a.setIds, forceSectorId = _a.forceSectorId;
    var appData = useCurrentApp();
    var sectorId = (_b = appData === null || appData === void 0 ? void 0 : appData.configuration) === null || _b === void 0 ? void 0 : _b.sectorId;
    var sectorData = useSector(sectorId);
    var resource = useResources(ids || []);
    var _c = useState(false), open = _c[0], setOpen = _c[1];
    var _d = React.useState(''), debouncedQuery = _d[0], setDebouncedQuery = _d[1];
    var searchResourcesQuery = useQuery(['allResources', debouncedQuery], function () { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, ResourceService.getAllResources({
                        name: debouncedQuery ? [debouncedQuery] : undefined,
                        // Need to add this as limit (50) cuts off some data if we fetch by all sectors
                        sectorIds: forceSectorId ? [forceSectorId] : undefined,
                        limit: {
                            offset: 0,
                            limit: 50,
                            sort: [
                                { field: "firstName", direction: "ASC" },
                                // This sort puts the restaurants first and then the tables which DO have capacity
                                { field: "capacity", direction: "ASC" }
                            ]
                        }
                    })];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response.content || []];
            }
        });
    }); });
    var queryResults = searchResourcesQuery.data || [];
    if (forceSectorId) {
        // When searching tables, we need to add the condition on parentId
        if ((sectorData === null || sectorData === void 0 ? void 0 : sectorData.sectorType) === SectorType.RESTAURANT) {
            queryResults = queryResults.filter(function (resource) { var _a; return ((_a = resource.sectorIds) === null || _a === void 0 ? void 0 : _a.includes(forceSectorId)) || resource.parentId !== undefined; });
        }
        else {
            queryResults = queryResults.filter(function (resource) { var _a; return (_a = resource.sectorIds) === null || _a === void 0 ? void 0 : _a.includes(forceSectorId); });
        }
    }
    var debouncedSearch = useMemo(function () {
        return debounce(function (query) {
            setDebouncedQuery(query);
        }, 500);
    }, []);
    useEffect(function () {
        return function () {
            debouncedSearch.cancel();
        };
    }, [debouncedSearch]);
    return (_jsx(Autocomplete, { id: "resource-find", onOpen: function () {
            setOpen(true);
            searchResourcesQuery.refetch();
        }, onClose: function () { return setOpen(false); }, multiple: true, isOptionEqualToValue: function (option, value) { return option.id === value.id; }, getOptionLabel: function (option) { return option.name || ''; }, options: open ? queryResults || [] : resource, loading: searchResourcesQuery.isLoading, filterOptions: function (x) { return x; }, fullWidth: true, value: resource, onChange: function (e, value) {
            setIds(value.map(function (v) { return v.id; }) || []);
        }, renderInput: function (params) { return (_jsx(TextField, __assign({}, params, { size: 'small', fullWidth: true, onChange: function (e) {
                var newQuery = e.target.value;
                debouncedSearch(newQuery);
            }, InputProps: __assign(__assign({}, params.InputProps), { endAdornment: (_jsxs(React.Fragment, { children: [searchResourcesQuery.isLoading ?
                            _jsx(CircularProgress, { color: "inherit", size: 20 }) : null, params.InputProps.endAdornment] })) }) }))); } }));
};
export default FilterResourceIdInput;
